export { default as PastTrade } from "./PastTrade.svelte";
